export default "__VITE_ASSET__DFhbrtVT__"